// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[2].use[1]!../../../node_modules/postcss-loader/dist/cjs.js!../../style/theme.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.actionButton_otx9d,
.addBlueprint_TF7Zc {
	font-size: 18px;
}

.blueprintScreen_gG1lz {
	position: absolute;
	top: 50px;
	left: 0;
	right: 0;
	bottom: 0;
	overflow: hidden;
	display: flex;
	flex-direction: column;
}

.pad_WIi7v {
	padding: 10px;
}

.screen_kI2BU {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	display: flex;
	flex-direction: column;
}

.header_ZQ0QS {
	display: flex;
	padding: 10px 26px 10px 20px;
	text-align: right;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	border-bottom: 5px solid var(--background);
  /*var( --border-color );*/;
}

.screen_kI2BU .addBlueprint_TF7Zc {
	border-radius: 50%;
	width: 40px;
	height: 40px;
}

.noItems_VVghb {
	text-align: left;
	padding: 20px 20px;
}

.devIcon_k6Nkw,
.orgIcon_vftOQ {
	display: inline-flex;
	justify-content: center;
	align-items: center;
	background: var(--purple);
	border-radius: 17px;
	width: 34px;
	height: 34px;
	margin-right: 10px;
	font-size: 18px;
}

.devIcon_k6Nkw > i,
.orgIcon_vftOQ > i {
	color: white;
}

.devIcon_k6Nkw > i {
	margin-top: 1px;
  /* adjust chip */;
}`, "",{"version":3,"sources":["webpack://./src/screens/blueprint/style.css"],"names":[],"mappings":"AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,SAAS;CACT,OAAO;CACP,QAAQ;CACR,SAAS;CACT,gBAAgB;CAChB,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,kBAAkB;CAClB,MAAM;CACN,OAAO;CACP,QAAQ;CACR,SAAS;CACT,aAAa;CACb,sBAAsB;AACvB;;AAEA;CACC,aAAa;CACb,4BAA4B;CAC5B,iBAAiB;CACjB,mBAAmB;CACnB,8BAA8B;CAC9B,mBAAmB;CACnB,0CAA0C;EACzC,yBAAyB;AAC3B;;AAEA;CACC,kBAAkB;CAClB,WAAW;CACX,YAAY;AACb;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;;CAEC,oBAAoB;CACpB,uBAAuB;CACvB,mBAAmB;CACnB,yBAAyB;CACzB,mBAAmB;CACnB,WAAW;CACX,YAAY;CACZ,kBAAkB;CAClB,eAAe;AAChB;;AAEA;;CAEC,YAAY;AACb;;AAEA;CACC,eAAe;EACd,gBAAgB;AAClB","sourcesContent":["@import \"../../style/theme.css\";\n\n.actionButton,\n.addBlueprint {\n\tfont-size: 18px;\n}\n\n.blueprintScreen {\n\tposition: absolute;\n\ttop: 50px;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\toverflow: hidden;\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.pad {\n\tpadding: 10px;\n}\n\n.screen {\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\tright: 0;\n\tbottom: 0;\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.header {\n\tdisplay: flex;\n\tpadding: 10px 26px 10px 20px;\n\ttext-align: right;\n\tflex-direction: row;\n\tjustify-content: space-between;\n\talign-items: center;\n\tborder-bottom: 5px solid var(--background);\n  /*var( --border-color );*/;\n}\n\n.screen .addBlueprint {\n\tborder-radius: 50%;\n\twidth: 40px;\n\theight: 40px;\n}\n\n.noItems {\n\ttext-align: left;\n\tpadding: 20px 20px;\n}\n\n.devIcon,\n.orgIcon {\n\tdisplay: inline-flex;\n\tjustify-content: center;\n\talign-items: center;\n\tbackground: var(--purple);\n\tborder-radius: 17px;\n\twidth: 34px;\n\theight: 34px;\n\tmargin-right: 10px;\n\tfont-size: 18px;\n}\n\n.devIcon > i,\n.orgIcon > i {\n\tcolor: white;\n}\n\n.devIcon > i {\n\tmargin-top: 1px;\n  /* adjust chip */;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actionButton": `actionButton_otx9d`,
	"addBlueprint": `addBlueprint_TF7Zc`,
	"blueprintScreen": `blueprintScreen_gG1lz`,
	"pad": `pad_WIi7v`,
	"screen": `screen_kI2BU`,
	"header": `header_ZQ0QS`,
	"noItems": `noItems_VVghb`,
	"devIcon": `devIcon_k6Nkw`,
	"orgIcon": `orgIcon_vftOQ`
};
export default ___CSS_LOADER_EXPORT___;
